(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["harmony-subscription"] && !Shopify.designMode) return;
  try {
    document.addEventListener('variant:change', function(evt) {
  let variant = evt.detail.variant;
  if (variant) {
    let newPrice = (variant.price / 100).toFixed(2); // Convert cents to dollars
    let formattedPrice = newPrice.replace(/\.00$/, ''); // Remove trailing .00 if needed

    let newSubscriptionPrice = (variant.price / 100 * 0.80).toFixed(2); // Convert cents to dollars
    let formattedSubscriptionPrice = newSubscriptionPrice.replace(/\.00$/, ''); // Remove trailing .00 if needed

    // Update the HTML content
    let priceContainer = document.querySelector('.one-time-price span');
    if (priceContainer) {
      priceContainer.textContent = `₪${formattedPrice}`;
    }
    
    let priceSubContainerComp = document.querySelector('.subscription-price .product__price--compare');
    if (priceSubContainerComp) {
      priceSubContainerComp.textContent = `₪${formattedPrice}`;
    }

    let priceSubContainer = document.querySelector('.subscription-price .product__price');
    if (priceSubContainer) {
      priceSubContainer.textContent = `₪${formattedSubscriptionPrice}`;
    }

    let titleContainer = document.querySelector('.subscription-nospace .title strong');
    if (titleContainer) {
      let variantId = variant.id;
      let variantInput = document.querySelector(`input[data-variant-id="${variantId}"]`);
      if (variantInput) {
        let subscriptionTime = variantInput.getAttribute('data-subscription-time');
        titleContainer.textContent = subscriptionTime;
      } else {
        titleContainer.textContent = variant.title;
      }
    }
  }
});
document.addEventListener('DOMContentLoaded', function() {
  document.querySelectorAll('.one-time-fee, .subscription').forEach(function(container) {
    container.addEventListener('click', function(event) {
      // Only fire if you didn't directly click the radio
      if (event.target.tagName.toLowerCase() !== 'input') {
        let input = container.querySelector('input[type="radio"]');
        if (input) {
          input.checked = true;
          // Optionally trigger change event if necessary
          input.dispatchEvent(new Event('change', { bubbles: true }));
        }
      }
    });
  });
});
  } catch(e) { console.error(e); }
})();

})();
